import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { OrganizationCreationOptions } from '../../../../../../common/src/options/organization-creation.options';
import { OrganizationModel } from '../../../../../../common/dist/angular/models/organization.model';
import { TransformerClassType } from '../../../../modules/src/lib/core/interceptors/transformer.http-interceptor';
import { BaseApiController } from './base.api-controller';
import { EnvironmentManager } from '../../../../modules/src/lib/core/managers/environment.manager';

@Injectable()
export class OrganizationApiController extends BaseApiController {
  constructor(private readonly httpClient: HttpClient,
              environmentManager: EnvironmentManager) {
    super(environmentManager);
  }

  public static map(organizationModel: OrganizationModel): OrganizationModel {
    if (organizationModel.activeLicense?.trialEnd) {
      organizationModel.activeLicense.trialEnd = new Date(organizationModel.activeLicense.trialEnd);
    }
    if (organizationModel.activeLicense?.cancelAt) {
      organizationModel.activeLicense.cancelAt = new Date(organizationModel.activeLicense.cancelAt);
    }

    return {
      ...organizationModel,
      createdAt: new Date(organizationModel.createdAt),
      updatedAt: new Date(organizationModel.updatedAt),
    };
  }

  public async create(organizationCreationOptions: OrganizationCreationOptions): Promise<OrganizationModel> {
    return this.httpClient.post<OrganizationModel>(`${this.getApiUrl()}/api/organizations`, organizationCreationOptions, {
      context: new HttpContext().set(TransformerClassType, OrganizationModel),
    }).toPromise();
  }

  public async get(id: string): Promise<OrganizationModel> {
    return this.httpClient.get<OrganizationModel>(`${this.getApiUrl()}/api/organizations/${id}`, {
      context: new HttpContext().set(TransformerClassType, OrganizationModel),
    }).toPromise();
  }

  public async getCurrent(): Promise<OrganizationModel> {
    return this.get('current');
  }
}
